var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('image-cropper',{attrs:{"options":{
		aspectRatio: false,
		showPreview: false,
		croppedHeight: false,
		croppedWidth: false,
		previewQuality: 1,
		resultQuality: 1,
		dropareaMessage: 'Choose a file or drag it here'
	}},on:{"cropper-saved":_vm.saveImage}})}
var staticRenderFns = []

export { render, staticRenderFns }